var T = function (k, f) { var d = typeof window !== 'undefined' && window.VP_I18N; return d && typeof d[k] === 'string' ? d[k] : f; }; // vp-i18n T()
/* R39: product selection is not an order. No order network, image storage or payment. */
(function (root, factory) {
  "use strict";
  var api = factory();
  if (typeof module === "object" && module.exports) module.exports = api;
  if (root.document) api.mount(root);
})(typeof window === "undefined" ? {} : window, function () {
  "use strict";
  var KEY = "vp_product_draft_v1";
  var TTL = 30 * 60 * 1000;
  function text(value, limit) { return typeof value === "string" ? value.slice(0, limit).trim() : ""; }
  function makeDraft(input, now) {
    if (!/^[a-z0-9-]{1,80}$/.test(input.handle || "")) throw new Error("Invalid product");
    return {
      version: 1, createdAt: now, handle: input.handle,
      title: text(input.title, 120), pack: text(input.pack, 40), packLabel: text(input.packLabel, 100),
      // A displayed estimate only; NEVER submit this value as a charged price.
      estimate: /^\d{1,5}(\.\d{1,2})?$/.test(String(input.estimate)) ? String(input.estimate) : "",
      engraving: text(input.engraving, input.handle.includes("car") ? 8 : 24),
      notes: text(input.notes, 2000), world: input.world === "3d" ? "3d" : "brick"
    };
  }
  function readDraft(raw, now, handle) {
    try {
      var d = JSON.parse(raw);
      if (!d || d.version !== 1 || !Number.isFinite(d.createdAt) || now < d.createdAt || now - d.createdAt >= TTL) return null;
      if (handle && d.handle !== handle) return null;
      return makeDraft(d, d.createdAt);
    } catch (_) { return null; }
  }
  function photoError(file) {
    if (!file) return "";
    if (!["image/jpeg", "image/png", "image/webp"].includes(file.type)) return "Please choose a JPG, PNG or WebP image.";
    if (file.size <= 0 || file.size > 12 * 1024 * 1024) return "Please choose an image between 1 byte and 12 MB.";
    return "";
  }
  function draftBrief(d) {
    return ["Selected design: " + (d.title || d.handle), "Option: " + (d.packLabel || d.pack),
      d.estimate ? "Displayed estimate: $" + d.estimate + " USD (subject to confirmation)" : "",
      d.engraving ? "Personalisation: " + d.engraving : "", d.notes ? "Notes: " + d.notes : ""].filter(Boolean).join("\n");
  }
  function matches(groups, filter) { return filter === "all" || String(groups || "").split(/\s+/).includes(filter); }
  var PDP_IMAGE_TIMEOUT = 25000;
  // R56: image state belongs to this product's media, not its option/price/draft.
  // Only the selected image is requested. Failure never changes the selection.
  function createPdpImageController(win, scope, form) {
    if (!scope) return null;
    if (scope.__vpPdpImageController) return scope.__vpPdpImageController;
    var image = scope.querySelector("[data-pdp-hero]");
    var media = scope.querySelector(".vpd__media");
    if (!image || !media) return null;
    var frame = image.closest("figure") || media;
    var radios = Array.prototype.slice.call(form.querySelectorAll('input[name="pack"]'));
    var originalSrc = image.getAttribute("src") || image.src;
    var originalAlt = image.getAttribute("alt") || form.dataset.title || "Product image";
    var originalBusy = frame.getAttribute("aria-busy");
    var desired = null, pending = null, initialTimer = null, sequence = 0;
    var disposed = false, suspended = false, failure = false, cleanups = [], retryFocusPending = false;
    var feedback = win.document.createElement("div");
    feedback.className = "vpd__image-feedback";
    feedback.setAttribute("data-pdp-image-feedback", "");
    var imageStatus = win.document.createElement("p");
    imageStatus.className = "vpd__form-status";
    imageStatus.setAttribute("data-pdp-image-status", "");
    imageStatus.setAttribute("role", "status");
    imageStatus.setAttribute("aria-live", "polite");
    imageStatus.setAttribute("aria-atomic", "true");
    imageStatus.setAttribute("tabindex", "-1");
    var retry = win.document.createElement("button");
    retry.type = "button";
    retry.className = "vpd__submit vpd__image-retry";
    retry.setAttribute("data-pdp-image-retry", "");
    retry.textContent = "Retry image";
    feedback.appendChild(imageStatus);
    feedback.appendChild(retry);
    frame.insertAdjacentElement("afterend", feedback);
    function absolute(src) {
      try { return new URL(src, win.document.baseURI || win.location.href).href; }
      catch (_) { return src; }
    }
    function same(a, b) { return absolute(a) === absolute(b); }
    function labelFor(pack) {
      var label = pack && pack.closest("label");
      var title = label && label.querySelector("b");
      return title ? title.textContent.trim() : "Selected option";
    }
    function viewFor(pack) {
      var src = pack && pack.dataset.img;
      var label = src ? labelFor(pack) : "Product image";
      return { src: src || originalSrc, label: label,
        alt: src ? form.dataset.title + " — " + label : originalAlt };
    }
    var initialPack = radios.find(function (pack) { return pack.dataset.img && same(pack.dataset.img, originalSrc); });
    var displayed = initialPack ? viewFor(initialPack) : { src: originalSrc, label: "Product image", alt: originalAlt };
    function ready() { return !!(image.complete && image.naturalWidth > 0 && image.naturalHeight > 0); }
    function showing() {
      return ready() && same(image.getAttribute("src") || image.src, displayed.src) ?
        " Still showing " + displayed.label + "." : " No product image is currently available.";
    }
    function state(value, message) {
      media.dataset.pdpImageState = value;
      frame.setAttribute("aria-busy", String(value === "loading"));
      var active = win.document.activeElement;
      var focusedRetry = active === retry;
      var restoreRetryFocus = retryFocusPending && (focusedRetry || active === win.document.body);
      if ((focusedRetry || restoreRetryFocus) && value === "ready" && !message) message = desired.label + " image loaded.";
      imageStatus.textContent = message || "";
      // Keep status separate from packaging, upload, cart and handoff messages.
      feedback.hidden = value === "ready" && !message;
      retry.hidden = value === "ready";
      retry.disabled = value !== "error";
      if (value !== "loading") {
        retryFocusPending = false;
        if ((focusedRetry || restoreRetryFocus) && retry.hidden) imageStatus.focus({ preventScroll: true });
        else if (restoreRetryFocus && value === "error") retry.focus({ preventScroll: true });
      }
    }
    function clearInitial() {
      if (initialTimer !== null) win.clearTimeout(initialTimer);
      initialTimer = null;
    }
    function cancel() {
      sequence++;
      retryFocusPending = false;
      clearInitial();
      if (!pending) return;
      pending.loader.onload = pending.loader.onerror = null;
      win.clearTimeout(pending.timer);
      pending = null;
    }
    function showFailure() {
      failure = true;
      state("error", "Could not load " + desired.label + "." + showing() + " Your option is unchanged. Retry image to try again.");
    }
    function inspect() {
      if (disposed || suspended || pending || !desired) return;
      var currentSrc = image.getAttribute("src") || image.src;
      if (ready()) {
        clearInitial();
        if (same(currentSrc, desired.src)) {
          displayed = desired;
          failure = false;
          if (media.dataset.pdpImageState !== "ready") state("ready", "");
        } else if (failure) showFailure();
        return;
      }
      // A late event from the retained image must not erase a failed choice.
      if (failure || image.complete) { clearInitial(); showFailure(); return; }
      state("loading", "Loading " + desired.label + "…");
      if (initialTimer !== null) return;
      var token = sequence;
      var timer = win.setTimeout(function () {
        if (initialTimer === timer) initialTimer = null;
        if (disposed || suspended || pending || token !== sequence) return;
        if (ready() && same(image.getAttribute("src") || image.src, desired.src)) inspect();
        else showFailure();
      }, PDP_IMAGE_TIMEOUT);
      initialTimer = timer;
    }
    function requestImage(restoreFocus) {
      if (disposed || suspended || !desired || !desired.src || pending) return;
      cancel();
      // Disabling a focused button can move focus to body before load finishes.
      retryFocusPending = restoreFocus === true;
      failure = false;
      var view = desired, token = sequence, loader;
      state("loading", "Loading " + view.label + "…" + showing());
      try { loader = new win.Image(); }
      catch (_) { showFailure(); return; }
      var request = { loader: loader, timer: null, loaded: false };
      pending = request;
      function current() { return !disposed && !suspended && token === sequence && pending === request; }
      function release() {
        loader.onload = loader.onerror = null;
        win.clearTimeout(request.timer);
        pending = null;
      }
      function failed() {
        if (!current()) return;
        release(); showFailure();
      }
      function commit() {
        if (!current()) return;
        release();
        // Decode has succeeded. The previous image is untouched until here.
        image.removeAttribute("srcset");
        image.removeAttribute("sizes");
        image.setAttribute("src", view.src);
        image.setAttribute("alt", view.alt);
        displayed = view;
        failure = false;
        state("ready", view.label + " image loaded.");
      }
      loader.decoding = "async";
      loader.onload = function () {
        if (!current() || request.loaded) return;
        request.loaded = true;
        if (!(loader.naturalWidth > 0 && loader.naturalHeight > 0)) { failed(); return; }
        if (typeof loader.decode !== "function") { commit(); return; }
        try { Promise.resolve(loader.decode()).then(commit, failed); }
        catch (_) { failed(); }
      };
      loader.onerror = failed;
      request.timer = win.setTimeout(failed, PDP_IMAGE_TIMEOUT);
      try { loader.src = view.src; } catch (_) { failed(); }
    }
    function select(pack, reason) {
      if (disposed) return;
      if (reason === "resume") suspended = false;
      if (suspended) return;
      var view = viewFor(pack);
      var changed = !desired || !same(desired.src, view.src);
      if (!changed && pending) return;
      if (changed) { cancel(); failure = false; }
      desired = view;
      if (same(image.getAttribute("src") || image.src, view.src)) {
        inspect();
      } else if (reason === "resume") {
        // BFCache restoration never restarts an interrupted/failed request.
        showFailure();
      } else if (changed || reason === "choice") {
        requestImage();
      } else if (failure) showFailure();
    }
    function listen(node, type, handler) {
      node.addEventListener(type, handler);
      cleanups.push(function () { node.removeEventListener(type, handler); });
    }
    function suspend() {
      if (disposed) return;
      suspended = true; cancel();
      frame.setAttribute("aria-busy", "false");
    }
    function dispose() {
      if (disposed) return;
      disposed = true; cancel();
      cleanups.splice(0).forEach(function (cleanup) { cleanup(); });
      feedback.remove();
      if (originalBusy === null) frame.removeAttribute("aria-busy");
      else frame.setAttribute("aria-busy", originalBusy);
      delete media.dataset.pdpImageState;
      delete scope.__vpPdpImageController;
    }
    listen(image, "load", inspect);
    listen(image, "error", inspect);
    listen(retry, "click", function () { if (!retry.disabled) requestImage(win.document.activeElement === retry); });
    listen(win.document, "focusin", function (event) {
      if (event.target !== retry && event.target !== win.document.body) retryFocusPending = false;
    });
    listen(win.document, "pointerdown", function (event) {
      if (event.target !== retry) retryFocusPending = false;
    });
    listen(win, "pagehide", function (event) { if (event.persisted) suspend(); else dispose(); });
    var controller = { select: select, dispose: dispose };
    scope.__vpPdpImageController = controller;
    return controller;
  }
  function mount(win) {
    var doc = win.document;
    doc.querySelectorAll("[data-catalog-browser]").forEach(function (section) {
      if (section.dataset.catalogMounted) return;
      section.dataset.catalogMounted = "true";
      var buttons = section.querySelectorAll("[data-catalog-filter]");
      var cards = section.querySelectorAll(".cat-card");
      var filterStrip = section.querySelector(".catalog-filters");
      function revealFilter(button) {
        // Scroll only this horizontal strip. scrollIntoView can also move the
        // document, especially after filtering shortens the product grid.
        if (!filterStrip || filterStrip.scrollWidth <= filterStrip.clientWidth ||
            !filterStrip.getBoundingClientRect || !button.getBoundingClientRect) return;
        var stripRect = filterStrip.getBoundingClientRect(), buttonRect = button.getBoundingClientRect();
        var inset = buttonRect.width + 8 <= filterStrip.clientWidth ? 4 : 0;
        var left = stripRect.left + (filterStrip.clientLeft || 0) + inset;
        var right = stripRect.left + (filterStrip.clientLeft || 0) + filterStrip.clientWidth - inset;
        var delta = buttonRect.left < left ? buttonRect.left - left : buttonRect.right > right ? buttonRect.right - right : 0;
        if (Number.isFinite(delta) && delta) filterStrip.scrollLeft += delta;
      }
      section.querySelector(".catalog-tools").hidden = false;
      buttons.forEach(function (button) {
        button.addEventListener("click", function () {
          var count = 0;
          cards.forEach(function (card) { card.hidden = !matches(card.dataset.catalogGroups, button.dataset.catalogFilter); if (!card.hidden) count++; });
          buttons.forEach(function (b) { b.setAttribute("aria-pressed", String(b === button)); });
          section.querySelector("[data-catalog-count]").textContent = count + (count === 1 ? T('js.catalog.count_one', " design") : T('js.catalog.count_many', " designs"));
          revealFilter(button);
        });
      });
    });
    var form = doc.querySelector("[data-pdp-form][data-request-url]");
    if (form && !form.dataset.experienceMounted) {
      form.dataset.experienceMounted = "true";
      var scope = form.closest(".vpd");
      var photo = form.querySelector("[data-pdp-photo]");
      var status = form.querySelector("[data-pdp-status]");
      var button = form.querySelector('[type="submit"]');
      var hasCart = !!(win.VP_CART && typeof win.VP_CART.add === "function");
      var hint = form.querySelector("#pdp-photo-hint");
      var packRadios = Array.prototype.slice.call(form.querySelectorAll('input[name="pack"]'));
      var packStatus = form.querySelector("[data-pdp-pack-status]");
      function selected() { return form.querySelector('input[name="pack"]:checked'); }
      function showPackNotice(message) {
        if (!message && !packStatus) return;
        // Packaging feedback must coexist with photo, storage and cart errors.
        if (!packStatus) {
          packStatus = doc.createElement("p");
          packStatus.className = "vpd__form-status";
          packStatus.setAttribute("data-pdp-pack-status", "");
          packStatus.setAttribute("role", "status");
          packStatus.setAttribute("aria-live", "polite");
          packStatus.setAttribute("aria-atomic", "true");
          if (status && status.insertAdjacentElement) status.insertAdjacentElement("afterend", packStatus);
          else form.appendChild(packStatus);
        }
        packStatus.textContent = message;
        packStatus.hidden = !message;
      }
      function writePackUrl(value) {
        try {
          var url = new URL(win.location.href);
          if (value) url.searchParams.set("pack", value); else url.searchParams.delete("pack");
          if (url.href === win.location.href) return true;
          if (!win.history || typeof win.history.replaceState !== "function") return false;
          win.history.replaceState(win.history.state, "", url.pathname + url.search + url.hash);
          return true;
        } catch (_) { return false; }
      }
      function applyPackLink() {
        var values;
        try { values = new URL(win.location.href).searchParams.getAll("pack"); } catch (_) { return; }
        if (!values.length) return;
        // The current product's enabled radios are the complete allowlist.
        // URL prices, images and other fields never supply product state.
        var wanted = values.length === 1 ? packRadios.filter(function (radio) {
          return radio.value === values[0] && !radio.disabled &&
            !(typeof radio.matches === "function" && radio.matches(":disabled"));
        })[0] : null;
        if (wanted) {
          packRadios.forEach(function (radio) { radio.checked = radio === wanted; });
          return;
        }
        var current = selected();
        var labelRoot = current && current.closest("label");
        var label = labelRoot && labelRoot.querySelector("b");
        var message = "The packaging in this link is not available for this design. " +
          (label ? label.textContent : "The current option") + " remains selected. Choose an available packaging option.";
        if (!writePackUrl("")) message += " Your browser could not update the address; refreshing may restore the original packaging link.";
        showPackNotice(message);
      }
      function keepPackLinkCurrent(clearNotice) {
        var pack = selected(); if (!pack) return;
        if (!writePackUrl(pack.value)) {
          showPackNotice("Packaging updated, but your browser could not update the address. Refreshing may restore the packaging in the original link.");
        } else if (clearNotice) showPackNotice("");
      }
      var imageController = null;
      function sync(imageReason) {
        var pack = selected(); if (!pack) return;
        scope.querySelectorAll("[data-pdp-price]").forEach(function (n) { n.textContent = "$" + pack.dataset.price; });
        if (imageController) imageController.select(pack, imageReason);
      }
      packRadios.forEach(function (p) { p.addEventListener("change", function () { sync("choice"); keepPackLinkCurrent(true); }); });
      applyPackLink();
      imageController = createPdpImageController(win, scope, form);
      sync("initial");
      if (!hasCart) {
        form.querySelector("[data-pdp-preview]").hidden = false;
        form.querySelector("[data-pdp-action]").textContent = "Continue to request";
        photo.required = false;
        form.querySelector("[data-pdp-photo-required]").hidden = true;
        form.querySelector("[data-pdp-photo-optional]").hidden = false;
        hint.textContent = "Optional local file check only. Photos are not uploaded or saved here; share them in the studio reply thread.";
      }
      photo.addEventListener("change", function () {
        var file = photo.files && photo.files[0];
        var error = photoError(file);
        photo.setCustomValidity(error);
        hint.textContent = error || (file ? "Image format and size accepted. " + (hasCart ? "Your image will be attached when you continue." : "Checked on this device only; not uploaded or saved.") : "Choose a JPG, PNG or WebP image up to 12 MB.");
        status.textContent = error;
      });
      form.addEventListener("submit", async function (event) {
        event.preventDefault();
        if (button.disabled || !form.reportValidity()) return;
        var pack = selected();
        var draft = makeDraft({handle: form.dataset.handle, title: form.dataset.title, pack: pack.value,
          packLabel: pack.closest("label").querySelector("b").textContent, estimate: pack.dataset.price,
          engraving: form.elements.engraving.value, notes: form.elements.notes.value, world: doc.documentElement.dataset.world}, Date.now());
        button.disabled = true;
        if (hasCart) {
          try {
            status.textContent = "Adding your selection…";
            await win.VP_CART.add({handle: draft.handle, pack: draft.pack, engraving: draft.engraving, notes: draft.notes}, photo.files && photo.files[0]);
            status.textContent = "Selection added. Continue in your cart.";
          } catch (_) { status.textContent = "We could not add this item. Your details are still here; please try again."; }
          finally { button.disabled = false; }
          return;
        }
        try { win.sessionStorage.setItem(KEY, JSON.stringify(draft)); }
        catch (_) { status.textContent = "This browser cannot carry your selection to the next page. Your details are still here. Enable session storage or copy them before starting a request."; button.disabled = false; return; }
        var url = new URL(form.dataset.requestUrl, win.location.href);
        url.searchParams.set("product", draft.handle);
        url.searchParams.set("world", draft.world);
        win.location.assign(url.href);
      });
      win.addEventListener("pageshow", function (event) {
        // BFCache restores the user's radio state. It must win over an older URL.
        sync("resume"); button.disabled = false;
        if (event && event.persisted) keepPackLinkCurrent(false);
      });
      button.disabled = false;
    }
    var request = doc.querySelector("[data-custom-request]");
    if (!request || request.dataset.draftMounted) return;
    request.dataset.draftMounted = "true";
    var worldField = request.querySelector('[name="contact[world]"]');
    var designField = request.querySelector('[name="contact[selected_design]"]');
    var body = request.querySelector('[name="contact[body]"]');
    var selection = request.querySelector("[data-request-selection]");
    var summary = selection && selection.querySelector("[data-request-summary]");
    var review = request.querySelector("[data-request-review]");
    var reviewMessage = request.querySelector("[data-request-review-message]");
    var reviewConfirm = request.querySelector("[data-request-review-confirm]");
    var pendingReview = null;
    var addedReviewDescription = false;
    var reviewStateKey = "vpRequestReviewV1";
    var reviewStoragePrefix = "vp_request_review_v1:";
    var reviewEntry = null, restoreCandidate = null, restoreTimer = null, restoreReadFailed = false;
    var reviewStorageNotice = request.querySelector("[data-request-review-storage-status]");
    var designOptions = Array.from(request.querySelectorAll('[data-request-design-catalog] option'));
    function canonicalReviewOrigin(handle, world) {
      return designOptions.find(function (option) { return option.value === handle && option.dataset.designWorld === world; });
    }
    function readReviewEntry() {
      try {
        var entry = win.history && win.history.state && win.history.state[reviewStateKey];
        return entry && typeof entry.id === "string" && /^[a-z0-9-]{12,80}$/.test(entry.id) &&
          entry.path === new URL(win.location.href).pathname ? entry : null;
      } catch (_) { return null; }
    }
    function showReviewStorageNotice(message) {
      if (!message && !reviewStorageNotice) return;
      if (!reviewStorageNotice && typeof doc.createElement === "function" && typeof request.appendChild === "function") {
        reviewStorageNotice = doc.createElement("p");
        reviewStorageNotice.setAttribute("data-request-review-storage-status", "");
        reviewStorageNotice.setAttribute("role", "status");
        reviewStorageNotice.setAttribute("aria-live", "polite");
        request.appendChild(reviewStorageNotice);
      }
      if (reviewStorageNotice) { reviewStorageNotice.textContent = message; reviewStorageNotice.hidden = !message; }
    }
    function forgetReviewMarker() {
      restoreCandidate = null;
      restoreReadFailed = false;
      if (!reviewEntry) return true;
      var removed = false, detached = false;
      try { win.sessionStorage.removeItem(reviewStoragePrefix + reviewEntry.id); removed = true; } catch (_) {}
      try {
        var currentEntry = readReviewEntry();
        if (!currentEntry || currentEntry.id !== reviewEntry.id) detached = true;
        else {
          var state = Object.assign({}, win.history.state);
          delete state[reviewStateKey];
          win.history.replaceState(state, "", win.location.href);
          detached = true;
        }
      } catch (_) {}
      // Either removing the record or detaching this history entry prevents replay.
      reviewEntry = null;
      return removed || detached;
    }
    function saveReviewMarker() {
      try {
        if (!pendingReview || !canonicalReviewOrigin(pendingReview.handle, pendingReview.world) ||
            new URL(win.location.href).searchParams.has("product") ||
            !win.sessionStorage || typeof win.sessionStorage.setItem !== "function" ||
            !win.history || typeof win.history.replaceState !== "function") return false;
        var state = win.history.state;
        // Only merge ordinary records; preserve primitive/array/Date/Map state intact.
        if (state !== null && state !== undefined && Object.prototype.toString.call(state) !== "[object Object]") return false;
        var existing = readReviewEntry();
        var entry = existing || { id: Date.now().toString(36) + "-" + (Math.random().toString(36).slice(2) + "000000000000").slice(0, 12), path: new URL(win.location.href).pathname };
        // No title, form body, contact detail, photo or content fingerprint is persisted.
        var marker = { version: 1, handle: pendingReview.handle, world: pendingReview.world, createdAt: Date.now() };
        win.sessionStorage.setItem(reviewStoragePrefix + entry.id, JSON.stringify(marker));
        reviewEntry = entry;
        if (!existing) {
          var nextState = Object.assign({}, state);
          nextState[reviewStateKey] = entry;
          win.history.replaceState(nextState, "", win.location.href);
        }
        return true;
      } catch (_) {
        // An orphaned record must not be treated as refresh protection.
        if (reviewEntry && !readReviewEntry()) forgetReviewMarker();
        return false;
      }
    }
    function loadReviewMarker() {
      reviewEntry = readReviewEntry();
      if (!reviewEntry) return;
      // Any product parameter (including duplicate/invalid values) starts a new selection.
      if (new URL(win.location.href).searchParams.has("product")) { forgetReviewMarker(); return; }
      var stored;
      try { stored = win.sessionStorage.getItem(reviewStoragePrefix + reviewEntry.id); }
      catch (_) { restoreReadFailed = true; return; }
      try {
        var marker = JSON.parse(stored);
        var origin = marker && canonicalReviewOrigin(marker.handle, marker.world);
        if (!marker || marker.version !== 1 || !origin || !Number.isFinite(marker.createdAt) ||
            Date.now() < marker.createdAt || Date.now() - marker.createdAt >= TTL) { forgetReviewMarker(); return; }
        restoreCandidate = { handle: origin.value, world: origin.dataset.designWorld, title: origin.textContent };
      } catch (_) { forgetReviewMarker(); }
    }
    function describeReview(active) {
      var id = reviewMessage && reviewMessage.id;
      if (!body || !id || typeof body.getAttribute !== "function") return;
      var ids = (body.getAttribute("aria-describedby") || "").split(/\s+/).filter(Boolean);
      if (active && !ids.includes(id)) {
        ids.push(id); body.setAttribute("aria-describedby", ids.join(" "));
        addedReviewDescription = true;
      } else if (!active && addedReviewDescription) {
        ids = ids.filter(function (value) { return value !== id; });
        if (ids.length) body.setAttribute("aria-describedby", ids.join(" "));
        else body.removeAttribute("aria-describedby");
        addedReviewDescription = false;
      }
    }
    function clearSelectionUrl() {
      try {
        var requestUrl = new URL(win.location.href);
        requestUrl.searchParams.delete("product");
        if (win.history && typeof win.history.replaceState === "function") {
          win.history.replaceState(win.history.state, "", requestUrl.pathname + requestUrl.search + requestUrl.hash);
        }
      } catch (_) {
        // Keep the current form usable if URL/history access is blocked. Do
        // not force navigation, which would discard the customer's text.
      }
    }
    function updateReview(current) {
      if (!pendingReview) return;
      var label = current === "3d" ? "3D" : T('js.catalog.world_brick', "Brick");
      var from = pendingReview.world === "3d" ? "3D" : T('js.catalog.world_brick', "Brick");
      var message = (current === pendingReview.world ? T('js.catalog.review_back_prefix', "You are back in the ") + label + T('js.catalog.review_back_suffix', " collection. ") : T('js.catalog.review_switched_prefix', "You switched from ") + from + T('js.catalog.review_switched_to', " to ") + label + ". ") +
        T('js.catalog.review_cleared_prefix', "We cleared “") + pendingReview.title + T('js.catalog.review_cleared_suffix', "” as your selected design, but kept your edited text. ") +
        T('js.catalog.review_check', "Check any product, packaging or price details, then confirm this brief is for ") + label + ".";
      if (review && reviewMessage && reviewConfirm) {
        review.hidden = false;
        reviewMessage.textContent = message;
        reviewConfirm.textContent = T('js.catalog.review_keep_prefix', "Keep this brief for the ") + label + T('js.catalog.review_keep_suffix', " collection");
        describeReview(true);
        if (body && typeof body.setCustomValidity === "function") {
          body.setCustomValidity(T('js.catalog.review_validity_prefix', "Review and confirm this edited brief for the ") + label + T('js.catalog.review_validity_suffix', " collection before continuing."));
        }
      } else {
        // Older templates have no confirmation control: show the warning in
        // their existing summary rather than setting an un-clearable error.
        if (selection && summary) { selection.hidden = false; summary.textContent = message; }
      }
    }
    function finishReview(silent) {
      var hadPendingReview = !!pendingReview;
      pendingReview = null;
      var forgotten = forgetReviewMarker();
      if (hadPendingReview && body && typeof body.setCustomValidity === "function") body.setCustomValidity("");
      describeReview(false);
      if (review) review.hidden = true;
      if (reviewMessage) reviewMessage.textContent = "";
      showReviewStorageNotice(!forgotten && !silent ? T('js.catalog.review_storage_clear_failed', "The review is confirmed on this page, but your browser could not clear its reminder. It may appear again after refreshing.") : "");
    }
    function restoreReview(clearEmpty) {
      if (!body) return;
      if (!body.value.trim()) {
        if (clearEmpty && (pendingReview || restoreCandidate || reviewEntry)) finishReview(true);
        return;
      }
      if (!pendingReview && restoreCandidate) {
        pendingReview = restoreCandidate; restoreCandidate = null;
        if (designField) designField.value = "";
        if (selection) selection.hidden = true;
        if (summary) summary.textContent = "";
      }
      if (restoreReadFailed) showReviewStorageNotice(T('js.catalog.review_storage_restore_failed', "Your browser could not restore the collection-review reminder. Check any design, packaging or price details before continuing."));
      updateReview(doc.documentElement.dataset.world === "3d" ? "3d" : "brick");
    }
    if (reviewConfirm) reviewConfirm.addEventListener("click", function () {
      if (!pendingReview) return;
      finishReview(false);
      if (body) body.focus();
    });
    if (body) body.addEventListener("input", function () {
      // Fresh typing in an empty new form is not browser-restored old writing.
      if (!pendingReview && (restoreCandidate || restoreReadFailed)) { forgetReviewMarker(); showReviewStorageNotice(""); }
      if (pendingReview && !body.value.trim()) finishReview(true);
    });
    function syncRequestWorld() {
      var current = doc.documentElement.dataset.world === "3d" ? "3d" : "brick";
      if (worldField) worldField.value = current;
      if (draft && draft.world !== current) {
        if (body && inserted && body.value.startsWith(inserted)) {
          body.value = body.value.slice(inserted.length).trimStart();
        } else if (body && inserted && body.value.trim()) {
          // This is provenance, not text matching. Once the customer changes
          // an inserted brief, never guess which parts are safe to delete.
          pendingReview = { handle: draft.handle, world: draft.world, title: draft.title || draft.handle };
        }
        if (designField) designField.value = "";
        if (selection) selection.hidden = true;
        if (summary) summary.textContent = "";
        draft = null; inserted = ""; ownsSavedDraft = false;
        clearSelectionUrl();
        if (pendingReview && !saveReviewMarker()) {
          showReviewStorageNotice(T('js.catalog.review_storage_save_failed', "Review this brief before continuing. Your browser could not save the review reminder; it cannot be restored reliably after refreshing. Your writing is not saved by this reminder."));
        }
      }
      updateReview(current);
    }
    syncRequestWorld();
    win.addEventListener("vp:worldchange", syncRequestWorld);
    loadReviewMarker();
    restoreReview(false);
    win.addEventListener("pageshow", function () {
      syncRequestWorld();
      restoreReview(false);
      // Also check the next task: history traversal may restore form values after pageshow.
      if (typeof win.setTimeout === "function") {
        if (restoreTimer !== null && typeof win.clearTimeout === "function") win.clearTimeout(restoreTimer);
        restoreTimer = win.setTimeout(function () { restoreTimer = null; restoreReview(true); }, 0);
      } else restoreReview(true);
    });
    if (!selection) return;
    var products = new URL(win.location.href).searchParams.getAll("product");
    var product = products.length === 1 ? products[0] : null;
    if (!product) return;
    var raw;
    try { raw = win.sessionStorage.getItem(KEY); } catch (_) {}
    var draft = readDraft(raw, Date.now(), product);
    if (draft && draft.world !== (doc.documentElement.dataset.world === "3d" ? "3d" : "brick")) draft = null;
    var ownsSavedDraft = !!draft;
    var knownDesign = designOptions.find(function (option) { return option.value === product; });
    // Only canonical options embedded by the generator can create a design brief.
    // Never accept a title, price, quantity or free text from a query parameter.
    if (!draft && knownDesign && knownDesign.dataset.designWorld === doc.documentElement.dataset.world) {
      draft = makeDraft({handle: product, title: knownDesign.textContent, pack: "custom-brief", packLabel: "To be confirmed with the studio", world: knownDesign.dataset.designWorld}, Date.now());
    }
    selection.hidden = false;
    if (!draft) {
      summary.textContent = T('js.catalog.no_saved_selection', "No current saved selection. Please describe your design below; URL prices are not treated as a quote.");
      // A stale link for another product must not destroy a valid current draft.
      if (!readDraft(raw, Date.now())) {
        try { win.sessionStorage.removeItem(KEY); } catch (_) {}
      }
      selection.querySelector("[data-request-clear]").hidden = true;
      return;
    }
    var inserted = draftBrief(draft);
    if (designField) designField.value = draft.handle;
    summary.textContent = (draft.title || draft.handle) + " · " + (draft.packLabel || draft.pack);
    if (body && !body.value) body.value = inserted + "\n\n";
    selection.querySelector("[data-request-clear]").addEventListener("click", function () {
      if (ownsSavedDraft) {
        // A later selection may have replaced this tab's saved draft. Clear
        // only the exact record that supplied this request, never a new one.
        try { if (win.sessionStorage.getItem(KEY) === raw) win.sessionStorage.removeItem(KEY); } catch (_) {}
      }
      // Keep anything newly typed by the customer, remove only our exact prefix.
      if (body && inserted && body.value.startsWith(inserted)) body.value = body.value.slice(inserted.length).trimStart();
      selection.hidden = true;
      if (designField) designField.value = "";
      summary.textContent = "";
      draft = null; inserted = ""; ownsSavedDraft = false; raw = null; product = null; knownDesign = null;
      clearSelectionUrl();
      // Clearing selection does not confirm edited writing already awaiting review.
      if (!pendingReview) { forgetReviewMarker(); showReviewStorageNotice(""); }
      updateReview(doc.documentElement.dataset.world === "3d" ? "3d" : "brick");
      if (body) body.focus();
    });
  }
  return {makeDraft: makeDraft, readDraft: readDraft, photoError: photoError, draftBrief: draftBrief, matches: matches, mount: mount, TTL: TTL};
});
